import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import CannedFishProduct from 'models/CannedFishProduct'
import React, { useContext, useEffect, useState } from 'react'
import Select from 'react-select'
import { Col, Row, Alert } from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import {
  fishTypeOptions,
  packagingInitialState,
  packedInOptionsDefault,
  sizeOptionsDefault,
  tunaPackedInOptions,
  tunaSizeOptions,
  salmonPackedInOptions,
  salmonSizeOptions,
  sardinesPackedInOptions,
  sardinesSizeOptions,
} from './constants'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'

const CannedFishPackage = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  const [packaging, setPackaging] = useState(packagingInitialState)

  const [packedInOptions, setPackedInOptions] = useState(packedInOptionsDefault)
  const [sizeOptions, setSizeOptions] = useState(sizeOptionsDefault)

  const { setSelect, asterisk } = useFormUtils()

  const methods = useFormContext()

  const setOptions = () => {
    if (current.FishType === 'Chunk, Light Tuna') {
      setPackedInOptions(tunaPackedInOptions)
      setSizeOptions(tunaSizeOptions)
    } else if (current.FishType === 'Pink Salmon') {
      setPackedInOptions(salmonPackedInOptions)
      setSizeOptions(salmonSizeOptions)
    } else if (current.FishType === 'Sardines') {
      setPackedInOptions(sardinesPackedInOptions)
      setSizeOptions(sardinesSizeOptions)
    } else if (current.FishType === 'Chunk, Light Tuna') {
      setPackedInOptions(tunaPackedInOptions)
      setSizeOptions(tunaSizeOptions)
    } else if (current.FishType === 'Pink Salmon') {
      setPackedInOptions(salmonPackedInOptions)
      setSizeOptions(salmonSizeOptions)
    } else if (current.FishType === 'Sardines') {
      setPackedInOptions(sardinesPackedInOptions)
      setSizeOptions(sardinesSizeOptions)
    }
  }

  const optionsReset = () => {
    methods.reset(
      { PackedIn: '', Size: '' },
      {
        errors: false, // errors will not be reset
        dirtyFields: false, // dirtyFields will not be reset
        dirty: false, // dirty will not be reset
        isSubmitted: false,
        touched: false,
        isValid: false,
        submitCount: false,
      }
    )
  }

  useEffect(() => {
    setScrollToTop(true)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (current?.category === packagingInitialState.category) {
      const { category, subCategory, FishType, PackedIn, Size } = current
      setPackaging({
        category,
        subCategory,
        FishType: {
          value: FishType || '',
          label: FishType.length > 0 ? FishType : 'Fish Type',
        },
        PackedIn: {
          value: PackedIn || '',
          label: PackedIn.length > 0 ? PackedIn : 'Packed in',
        },
        Size: {
          value: Size || '',
          label: Size.length > 0 ? Size : 'Size',
        },
      })
      setOptions()
    } else if (!updating) {
      setCurrent(CannedFishProduct)
    }
    console.log(current)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  useEffect(() => {
    if (current?.fkCategory === packagingInitialState.category) {
      setOptions()
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  return (
    <Row>
      <Col xs={6}>
        <p>
          <strong>Fish Type {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={fishTypeOptions}
          name="FishType"
          value={packaging.FishType}
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Fish Type'}
          onChange={([selected]) => {
            optionsReset()
            console.log('selected is: ' + JSON.stringify(selected))
            setSelect(selected, 'FishType')
            return selected
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="FishType"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        <p>
          <strong>Size {current?.FishType !== '' ? asterisk : null}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={sizeOptions}
          name="Size"
          value={packaging.Size}
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Size'}
          isDisabled={current?.FishType === ''}
          onChange={([selected]) => {
            setSelect(selected, 'Size')
            return selected
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="Size"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
      </Col>
      <Col xs={6}>
        <p>
          <strong>
            Packed in {current?.FishType !== '' ? asterisk : null}
          </strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={packedInOptions}
          name="PackedIn"
          value={packaging.PackedIn}
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Packed In'}
          isDisabled={current?.FishType === ''}
          onChange={([selected]) => {
            setSelect(selected, 'PackedIn')
            return selected
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="PackedIn"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
      </Col>
    </Row>
  )
}

export default CannedFishPackage
